import { render, staticRenderFns } from "./sentence-swapper.vue?vue&type=template&id=54619d8c&scoped=true"
import script from "./sentence-swapper.vue?vue&type=script&lang=js"
export * from "./sentence-swapper.vue?vue&type=script&lang=js"
import style0 from "./sentence-swapper.vue?vue&type=style&index=0&id=54619d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54619d8c",
  null
  
)

export default component.exports